export const TOOL_CONDITION_OPTIONS = [
  { value: 'LIKE_NEW', label: 'Som ny' },
  { value: 'VERY_GOOD', label: 'Rigtig god' },
  { value: 'GOOD', label: 'God' },
  { value: 'USABLE', label: 'Brugbar' },
] as const;

export type ToolCondition = (typeof TOOL_CONDITION_OPTIONS)[number]['value'];

const LEGACY_TO_ENUM_MAP: Record<string, ToolCondition> = {
  like_new: 'LIKE_NEW',
  very_good: 'VERY_GOOD',
  good: 'GOOD',
  usable: 'USABLE',
  'Som ny': 'LIKE_NEW',
  'Rigtig god': 'VERY_GOOD',
  God: 'GOOD',
  Brugbar: 'USABLE',
};

const ENUM_TO_LABEL_MAP: Record<ToolCondition, string> = {
  LIKE_NEW: 'Som ny',
  VERY_GOOD: 'Rigtig god',
  GOOD: 'God',
  USABLE: 'Brugbar',
};

export const normalizeToolCondition = (value?: string | null): ToolCondition | '' => {
  if (!value) return '';

  const asEnum = value as ToolCondition;
  if (ENUM_TO_LABEL_MAP[asEnum]) {
    return asEnum;
  }

  return LEGACY_TO_ENUM_MAP[value] || '';
};

export const getToolConditionLabel = (value?: string | null): string => {
  const normalized = normalizeToolCondition(value);
  if (!normalized) {
    return value || '';
  }

  return ENUM_TO_LABEL_MAP[normalized];
};
